export default __webpack_public_path__ + "static/media/board-bg-smd.a8c9f771.png";